module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"main_page":{"title":{"full":"Das Job matching kann beginnen&nbsp;✨"},"message":{"full":"Deine Profildaten werden von uns verwendet, um Sie mit Unternehmen und deren Sales Jobs zu matchen."},"skip_cta":"Überspringen und später ausfüllen","create_profile_cta":{"full":"Matcht Mich!"},"trusted_by":"vorqualifizierte Sales Talent","num_sales_talent":"15.000+"}}}')
  delete Component.options._Ctor
}
